import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { fetchEvent } from "../redux/actions/eventAction";
import { useAppDispatch } from "../redux/hook";
import Pagination from "../utils/Pagination";

export default function Events() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // Pagination start
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(3);
  // Pagination end

  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadEvent = async () => {
    const data = {
      page: page,
      limit: limit,
    };

    const event = await dispatch(fetchEvent(data));
    if (typeof event.payload === "string" || event.payload === undefined) {
      setLoading(false);
      // navigate(checkError(homeEdit.payload));
    } else {
      setLoading(false);
      setEventData(event.payload.event);
      setTotalPages(event.payload.totalPages);
      setTotal(event.payload.total);
      setPage(event.payload.page);
      setLimit(event.payload.limit);
    }
  };

  useEffect(() => {
    loadEvent(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative lg:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-6 text-center">
          <h3 className="mb-4 md:text-2xl text-xl font-medium">
            {t("external.event.our_events")}
          </h3>

          <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
            {t("external.event.here_there_are_some_of_our_events")}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 mt-6 gap-6">
          {eventData.map((item, index) => {
            return (
              <ul className="space-y-6" key={index}>
                <li className="rounded-xl shadow dark:shadow-gray-800 p-6 bg-white dark:bg-slate-900">
                  <div className="flex items-center pb-6 border-b border-gray-100 dark:border-gray-800">
                    <img
                      src={
                        process.env.REACT_APP_API_URL +
                        "/wwwroot/images/" +
                        item.image_file
                      }
                      className="h-14 w-14 rounded-full shadow dark:shadow-gray-800"
                      alt=""
                    />

                    <div className="ps-3">
                      <Link
                        to={`/event/${item.id}`}
                        className="text-[16px] font-medium hover:text-orange-500 duration-500"
                      >
                        {item.name}
                      </Link>
                      <p className="text-slate-400 dark:text-white/60">
                        {moment(item?.start_date).format("DD/MM/YYYY")}{" "}
                        {item?.start_time}
                      </p>
                    </div>
                  </div>

                  <div className="mt-6">
                    <p className="text-slate-400 dark:text-white/60">
                      {item.description.substring(0, 35)}...
                    </p>
                    {/* <ul className="list-none mb-0 text-amber-400 mt-2">
                      <li className="inline">
                        <i className="mdi mdi-star"></i>
                      </li>
                      <li className="inline">
                        <i className="mdi mdi-star"></i>
                      </li>
                      <li className="inline">
                        <i className="mdi mdi-star"></i>
                      </li>
                      <li className="inline">
                        <i className="mdi mdi-star"></i>
                      </li>
                      <li className="inline">
                        <i className="mdi mdi-star"></i>
                      </li>
                    </ul> */}
                  </div>
                </li>
              </ul>
            );
          })}
        </div>
        <div className="place-items-center text-center">
          <Link to="/space" className="sub-menu-item">
            {t("external.event.click_here_to_see_next_events")}
          </Link>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          limit={limit}
          setLimit={setLimit}
          total={total}
        />
      </div>
    </>
  );
}
